import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿El material es para siempre?',
  a: 'Sí. Pago único. Acceso de por vida. Actualizaciones incluidas.'
}, {
  q: '¿Puedo leerlo desde el celular?',
  a: 'Sí. Todos los PDF están optimizados para móvil, tablet y PC.'
}, {
  q: '¿Sirve para cualquier Obra Social?',
  a: 'Sí. IOMA, PAMI, OSDE y todas las prepagas principales de Argentina.'
}, {
  q: '¿Cuándo recibo el material?',
  a: 'Inmediatamente después del pago recibís todo por email.'
}, {
  q: '¿Sirve si ya tengo experiencia como AT?',
  a: 'Sí. El sistema tiene profundidad para AT principiantes y para profesionales con años de recorrido.'
}, {
  q: '¿Sirve para AT domiciliarios y escolares?',
  a: 'Sí. Incluye modelos de redacción para ambos contextos.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-14 px-4 sm:px-6 lg:px-8 max-w-3xl mx-auto" data-id="element-65">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6
    }} className="text-center mb-12" data-id="element-66">
        <h2 className="text-3xl md:text-4xl font-bold text-white font-heading mb-4 tracking-wider" data-id="element-67">
          PREGUNTAS FRECUENTES
        </h2>
        <div className="w-24 h-1 bg-gold-gradient mx-auto rounded-full" data-id="element-68" />
      </motion.div>

      <div className="space-y-4" data-id="element-69">
        {faqs.map((faq, index) => <motion.div key={index} initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4,
        delay: index * 0.1
      }} className="bg-[#0f1d36] border border-[#1a2b4c] rounded-xl overflow-hidden" data-id="element-70">
            <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" data-id="element-71">
              <span className="text-lg font-medium text-white pr-4" data-id="element-72">
                {faq.q}
              </span>
              <ChevronDown className={`w-5 h-5 text-[#d4af37] transition-transform duration-300 shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-73" />
            </button>
            <AnimatePresence data-id="element-74">
              {openIndex === index && <motion.div initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.3
          }} data-id="element-75">
                  <div className="px-6 pb-5 text-[#a0aec0]" data-id="element-76">{faq.a}</div>
                </motion.div>}
            </AnimatePresence>
          </motion.div>)}
      </div>
    </section>;
}